// extracted by mini-css-extract-plugin
module.exports = {"camp-F":"F_camp-F__aXmqy"};